__turbopack_context__.v({
  "icon": "Icons-module-scss-module__wtjCqa__icon",
});
